var imgStorie = document.querySelectorAll('.stories ul li img');
for (var i = 0; i < imgStorie.length; i++) {
  (function(index) {
    imgStorie[index].addEventListener('click', function(event) {
      document.querySelector('.modal-reel-' + (index + 1)).classList.add("active");
      var video = document.querySelector('.modal-reel-' + (index + 1) + ' video');

      video.play();

      const modalReel = document.querySelector('.modal-reel-' + (index + 1));
      modalReel.addEventListener('mousemove', function(event) {
          if (!event.target.closest('video')) {
            if ( document.querySelector('mouse-cursor').classList.contains("active") === false ){
              document.querySelector('mouse-cursor').classList.add("active");
            }
          }else{
            if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
              document.querySelector('mouse-cursor').classList.remove("active");
            }
          }
      });

      modalReel.onclick = function() {
        if (!event.target.closest('video')) {
          video.pause();
          document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
          if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
            document.querySelector('mouse-cursor').classList.remove("active");
          }
        }
      };

      video.addEventListener('ended', () => {
        document.querySelector('.modal-reel-' + (index + 1)).classList.remove("active");
        if ( document.querySelector('mouse-cursor').classList.contains("active") === true ){
          document.querySelector('mouse-cursor').classList.remove("active");
        }
      });
      
    });
  })(i);
}


function playAudio(audioId) {
  const audios = document.querySelectorAll('audio');

  audios.forEach(audio => {
    if (!audio.paused && audio.id !== audioId) {
      audio.pause();
      audio.parentElement.querySelector('svg[class*="play-extrait"]').style.cssText = "display: block;";
      audio.parentElement.querySelector('svg[class*="pause-extrait"]').style.cssText = "display: none;";
    }
  });

  document.getElementById(audioId).play();
}


if (!!document.querySelector(".product__info .product__rating") === true){
  document.querySelector(".product__info .product__rating").onclick = function() {
    var topReviews = document.querySelector(".shopify-section.app-section:has(.jdgm-carousel-wrapper)").offsetTop;
    window.scrollTo({top: (topReviews - 100),behavior: 'smooth'});
  };
}


document.addEventListener("DOMContentLoaded", function() {
  if (!!document.querySelector(".en-savoir-plus") === true){
    var width_screen = window.innerWidth;
    
    document.querySelector(".en-savoir-plus").onclick = function() {
      if (!!document.querySelector(".second-product_info") === true){
        var element = document.querySelector(".second-product_info");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop - 40;
        }else{
          var topDesc = element.offsetTop;
        }
      }else{
        var element = document.querySelector("#description-redirection");
        if (!element.hasAttribute("open")) {
          element.querySelector(".product__accordion.details .details__summary").click();
        }
        if (width_screen < 1024) {
          var topDesc = element.offsetTop + 300;
        }else{
          var topDesc = element.offsetTop + 10;
        }
      }
      window.scrollTo({top: (topDesc + 60),behavior: 'smooth'});
    };
  }
});

document.addEventListener('DOMContentLoaded', function() {
  customElements.whenDefined('scroll-shadow').then(() => {
    const scrollShadow = document.querySelector('scroll-shadow');
    
    if (scrollShadow){
      // Supprimer seulement le template qui contient les flèches
      const template = scrollShadow.querySelector('template');
      if (template) {
        template.remove();
      }

      // Alternative : vider le shadow-root tout en gardant la structure
      if (scrollShadow.shadowRoot) {
        const slot = document.createElement('slot');
        scrollShadow.shadowRoot.innerHTML = '';
        scrollShadow.shadowRoot.appendChild(slot);
      }
    }
  });

  // Section video - Enlever le bouton Play quand on clique dessus
  var video_play_btn = document.querySelectorAll('.shopify-section[id*="video_with_text"] video-media button');
  for (var i = 0; i < video_play_btn.length; i++) {
    video_play_btn[i].addEventListener('click', function(event) {
      event.currentTarget.style.cssText = "display: none;";
    });
  }
});













document.addEventListener('DOMContentLoaded', function() {
  
  function gestionCoffretCadeau() {
    
    const coffretDataElement = document.getElementById('coffret-size-data');
    if (!coffretDataElement) return;
    
    const coffretData = JSON.parse(coffretDataElement.textContent);
    const COFFRET_PRODUCT_ID = 15020763578691;
    const COFFRET_HANDLE = "le-pack-cadeau-jewkids";
    
    // Parser les listes de variants étagères (strings → array de numbers)
    const etageresSimplesVariants = (coffretData.etageresSimplesVariants || '')
      .split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
    const etageresMinLVariants = (coffretData.etageresMinLVariants || '')
      .split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n));
    
    const SIZE_ORDER = ['BOX', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
    
    let isUpdatingCoffret = false;
    let coffretDesactive = false;
    let analyseTimer = null;
    
    function toggleDrawerInteractions(disable) {
      const drawerInner = document.querySelector('#CartDrawer');
      const checkoutButton = document.querySelector('.drawer__footer-buttons>.button--primary');
      
      if (drawerInner) {
        drawerInner.style.pointerEvents = disable ? 'none' : '';
      }
      
      if (checkoutButton) {
        if (disable) {
          checkoutButton.setAttribute('aria-busy', 'true');
          checkoutButton.setAttribute('aria-disabled', 'true');
        } else {
          checkoutButton.removeAttribute('aria-busy');
          checkoutButton.removeAttribute('aria-disabled');
        }
      }
    }
    
    // ========================================
    // CALCUL TAILLE COFFRET CADEAU (produit visible client)
    // Logique d'origine — 5 tailles BOX/XS/S/M/L
    // ========================================
    function determineCoffretSize(speakers, figurines, accessoires) {
      let size = '';
      
      if (speakers === 0) {
        if (figurines >= 1 && figurines <= 2) size = 'XS';
        else if (figurines >= 3 && figurines <= 4) size = 'S';
        else if (figurines >= 5 && figurines <= 8) size = 'M';
        else if (figurines >= 9 && figurines <= 12) size = 'L';
      } else if (speakers === 1) {
        if (figurines === 0) size = 'BOX';
        else if (figurines === 1) size = 'XS';
        else if (figurines >= 2 && figurines <= 3) size = 'S';
        else if (figurines >= 4 && figurines <= 5) size = 'M';
        else if (figurines >= 6 && figurines <= 7) size = 'L';
      } else if (speakers === 2) {
        if (figurines === 0) size = 'XS';
        else if (figurines === 1) size = 'S';
        else if (figurines >= 2 && figurines <= 3) size = 'M';
        else if (figurines >= 4 && figurines <= 6) size = 'L';
      } else if (speakers >= 3) {
        size = 'L';
      }
      
      if (size !== '' && accessoires > 0) {
        const sizeOrder = ['BOX', 'XS', 'S', 'M', 'L'];
        let currentIndex = sizeOrder.indexOf(size);
        let cransToAdd = Math.min(accessoires, 2);
        let newIndex = Math.min(currentIndex + cransToAdd, sizeOrder.length - 1);
        size = sizeOrder[newIndex];
      }
      
      return size;
    }
    
    // ========================================
    // CALCUL TAILLE CARTON (note interne préparation)
    // Nouvelle logique — 7 tailles + MANUAL
    // ========================================
    function upgrade(size, n) {
      if (!size) return size;
      const idx = SIZE_ORDER.indexOf(size);
      if (idx === -1) return size;
      const newIdx = Math.min(idx + n, SIZE_ORDER.length - 1);
      return SIZE_ORDER[newIdx];
    }
    
    function maxSize(a, b) {
      const idxA = SIZE_ORDER.indexOf(a);
      const idxB = SIZE_ORDER.indexOf(b);
      if (idxA === -1) return b;
      if (idxB === -1) return a;
      return SIZE_ORDER[Math.max(idxA, idxB)];
    }
    
    // Étape A — Taille de base carton (livres + enceintes uniquement)
    function calculTailleCartonBase(nbLivres, nbEnceintes) {
      if (nbLivres >= 25) return { size: null, manual: true };
      
      // Cas A1 : Livres uniquement
      if (nbEnceintes === 0) {
        if (nbLivres === 0) return { size: 'BOX', manual: false };
        if (nbLivres <= 2) return { size: 'XS', manual: false };
        if (nbLivres <= 4) return { size: 'S', manual: false };
        if (nbLivres <= 8) return { size: 'M', manual: false };
        if (nbLivres <= 12) return { size: 'L', manual: false };
        if (nbLivres <= 16) return { size: 'XL', manual: false };
        if (nbLivres <= 24) return { size: 'XXL', manual: false };
      }
      
      // Cas A2 : 1 enceinte + livres
      if (nbEnceintes === 1) {
        if (nbLivres === 0) return { size: 'BOX', manual: false };
        if (nbLivres === 1) return { size: 'XS', manual: false };
        if (nbLivres <= 4) return { size: 'S', manual: false };
        if (nbLivres <= 7) return { size: 'M', manual: false };
        if (nbLivres <= 11) return { size: 'L', manual: false };
        if (nbLivres <= 13) return { size: 'XL', manual: false };
        if (nbLivres <= 24) return { size: 'XXL', manual: false };
      }
      
      // Cas A3 : 2 enceintes + livres
      if (nbEnceintes === 2 && nbLivres > 0) {
        if (nbLivres <= 4) return { size: 'S', manual: false };
        if (nbLivres <= 6) return { size: 'M', manual: false };
        if (nbLivres <= 10) return { size: 'L', manual: false };
        if (nbLivres <= 12) return { size: 'XL', manual: false };
        if (nbLivres <= 24) return { size: 'XXL', manual: false };
      }
      
      // Cas A4 : Enceintes uniquement
      if (nbLivres === 0 && nbEnceintes >= 1) {
        if (nbEnceintes === 1) return { size: 'BOX', manual: false };
        if (nbEnceintes === 2) return { size: 'S', manual: false };
        if (nbEnceintes <= 8) return { size: 'M', manual: false };
        return { size: null, manual: true };
      }
      
      // 3+ enceintes avec livres → non couvert
      if (nbEnceintes >= 3) return { size: null, manual: true };
      
      return { size: null, manual: false };
    }
    
    // Étape B — Surclassements carton
    function appliquerSurclassementsCarton(tailleBase, counts) {
      let size = tailleBase;
      let minSize = null;
      
      // B1 : Casques + Sacoches (cumulés)
      const nbHS = counts.casquesSacoches;
      if (nbHS === 1) size = upgrade(size, 1);
      else if (nbHS >= 2) size = upgrade(size, 2);
      
      // B2 : Malettes (+1 et minimum L)
      if (counts.malettes >= 1) {
        size = upgrade(size, 1);
        minSize = maxSize(minSize, 'L');
      }
      
      // B3a : Étagères simples (cumul)
      if (counts.etageresSimples >= 1) {
        size = upgrade(size, counts.etageresSimples);
      }
      
      // B3b : Étagères minimum L (cumul + min L)
      if (counts.etageresMinL >= 1) {
        size = upgrade(size, counts.etageresMinL);
        minSize = maxSize(minSize, 'L');
      }
      
      if (minSize) size = maxSize(size, minSize);
      
      return size;
    }
    
    function determineCartonSize(counts) {
      const base = calculTailleCartonBase(counts.nbLivres, counts.nbEnceintes);
      
      if (base.manual) return { size: null, manual: true };
      if (!base.size) return { size: null, manual: true };
      
      const finalSize = appliquerSurclassementsCarton(base.size, counts);
      
      if (!finalSize) return { size: null, manual: true };
      
      return { size: finalSize, manual: false };
    }
    
    function construireNote(tailleCarton, manual, noteActuelle) {
      const regex = /\d+x Carton\s*–\s*Taille [^\n]+/g;
      let note = (noteActuelle || '').replace(regex, '').trim();
      
      if (manual) {
        const ligneCarton = `1x Carton – Taille MANUAL (vérification manuelle)`;
        note = note ? `${note}\n${ligneCarton}` : ligneCarton;
      } else if (tailleCarton) {
        const ligneCarton = `1x Carton – Taille ${tailleCarton}`;
        note = note ? `${note}\n${ligneCarton}` : ligneCarton;
      }
      
      return note;
    }
    
    function getSectionsToRender() {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
        bubbles: true, 
        detail: { sections: sectionsToBundle } 
      }));
      return sectionsToBundle.length > 0 ? sectionsToBundle : ['cart-drawer', 'cart-icon-bubble'];
    }
    
    function rafraichirPanier(sections) {
      return fetch(`${theme.routes.cart_url}.js`)
        .then(r => r.json())
        .then(cartJson => {
          if (sections) {
            cartJson['sections'] = sections;
          }
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { 
            cart: cartJson, 
            line: 1, 
            name: 'update' 
          });
        });
    }
    
    function cartUpdate(updates, note) {
      const sections = getSectionsToRender();
      const body = { updates, sections };
      if (note !== undefined) body.note = note;
      
      return fetch(`${theme.routes.cart_update_url}`, {
        ...theme.utils.fetchConfig(),
        body: JSON.stringify(body)
      })
        .then(r => r.json())
        .then(parsedState => {
          rafraichirPanier(parsedState.sections);
          return parsedState;
        });
    }
    
    function cartAdd(variantId, quantity, message) {
      const sections = getSectionsToRender();
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity.toString());
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      
      if (message) {
        formData.append('properties[Message]', message);
      }
      
      const config = theme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      
      return fetch(`${theme.routes.cart_add_url}`, config)
        .then(r => r.json())
        .then(parsedState => {
          rafraichirPanier(parsedState.sections);
          return parsedState;
        });
    }
    
    function planifierAnalyse(delai = 500) {
      if (analyseTimer) clearTimeout(analyseTimer);
      
      // Bloquer le drawer immédiatement dès qu'une analyse est planifiée
      if (!coffretDesactive) {
        toggleDrawerInteractions(true);
      }
      
      analyseTimer = setTimeout(() => {
        analyseTimer = null;
        if (!coffretDesactive && !isUpdatingCoffret) {
          analyseEtMiseAJourCoffret();
        } else {
          // Si on n'analyse pas (désactivé ou déjà en cours), débloquer
          toggleDrawerInteractions(false);
        }
      }, delai);
    }
    
    function analyseEtMiseAJourCoffret(forcerReactivation = false) {
      
      if (coffretDesactive && !forcerReactivation) {
        toggleDrawerInteractions(false);
        return;
      }
      if (forcerReactivation) coffretDesactive = false;
      if (isUpdatingCoffret) return;
      
      isUpdatingCoffret = true;
      toggleDrawerInteractions(true);
      
      fetch('/cart.js', { cache: 'no-store' })
        .then(response => response.json())
        .then(cart => {
          
          if (coffretDesactive) {
            isUpdatingCoffret = false;
            toggleDrawerInteractions(false);
            return;
          }
          
          // Compteurs pour le coffret (logique d'origine)
          let speakersCount = 0;
          let figurinesCount = 0;
          let accessoiresCoffretCount = 0;
          
          // Compteurs pour le carton (nouvelle logique)
          const countsCarton = {
            nbEnceintes: 0,
            nbLivres: 0,
            casquesSacoches: 0,
            malettes: 0,
            etageresSimples: 0,
            etageresMinL: 0
          };
          
          let coffretsExistants = [];
          let messageExistant = null;
          let coffretQuantiteTotal = 0;
          
          cart.items.forEach((item, index) => {
            if (item.product_id === COFFRET_PRODUCT_ID || item.handle === COFFRET_HANDLE) {
              coffretsExistants.push({ ...item, line: index + 1 });
              coffretQuantiteTotal += item.quantity;
              if (!messageExistant && item.properties && item.properties.Message) {
                messageExistant = item.properties.Message;
              }
            }
            else if (item.handle === "coffret-decouverte") {
              speakersCount += item.quantity;
              figurinesCount += item.quantity;
              countsCarton.nbEnceintes += item.quantity;
              countsCarton.nbLivres += item.quantity;
            }
            else if (coffretData.speakers && coffretData.speakers.includes(item.product_id)) {
              speakersCount += item.quantity;
              countsCarton.nbEnceintes += item.quantity;
            }
            else if (coffretData.figurines && coffretData.figurines.includes(item.product_id)) {
              figurinesCount += item.quantity;
              countsCarton.nbLivres += item.quantity;
            }
            else if (coffretData.casquesSacoches && coffretData.casquesSacoches.includes(item.product_id)) {
              accessoiresCoffretCount += item.quantity;
              countsCarton.casquesSacoches += item.quantity;
            }
            else if (coffretData.malettes && coffretData.malettes.includes(item.product_id)) {
              accessoiresCoffretCount += item.quantity;
              countsCarton.malettes += item.quantity;
            }
            else if (etageresSimplesVariants.includes(item.variant_id)) {
              accessoiresCoffretCount += item.quantity;
              countsCarton.etageresSimples += item.quantity;
            }
            else if (etageresMinLVariants.includes(item.variant_id)) {
              accessoiresCoffretCount += item.quantity;
              countsCarton.etageresMinL += item.quantity;
            }
          });
          
          // Taille du coffret cadeau (produit client)
          const tailleNecessaire = determineCoffretSize(speakersCount, figurinesCount, accessoiresCoffretCount);
          
          // Taille du carton (note interne)
          const resultCarton = determineCartonSize(countsCarton);
          const tailleCarton = resultCarton.size;
          const isManualCarton = resultCarton.manual;
          
          const noteCalculee = construireNote(tailleCarton, isManualCarton, cart.note);
          
          // 1. Aucun coffret nécessaire mais il en existe → tout supprimer
          if (!tailleNecessaire && coffretsExistants.length > 0) {
            const updates = {};
            coffretsExistants.forEach(c => { updates[c.key] = 0; });
            
            cartUpdate(updates, noteCalculee)
              .finally(() => {
                setTimeout(() => {
                  isUpdatingCoffret = false;
                  toggleDrawerInteractions(false);
                }, 1500);
              });
            return;
          }
          
          // 2. Aucun coffret nécessaire et n'existe pas → juste maj note
          if (!tailleNecessaire || !coffretData.sizes[tailleNecessaire]) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteCalculee })
            }).finally(() => {
              isUpdatingCoffret = false;
              toggleDrawerInteractions(false);
            });
            return;
          }
          
          const variantIdNecessaire = coffretData.sizes[tailleNecessaire];
          
          // 3. Coffret(s) existe(nt)
          if (coffretsExistants.length > 0) {
            
            const coffretBonVariant = coffretsExistants.find(c => c.variant_id === variantIdNecessaire);
            const coffretsMauvaisVariant = coffretsExistants.filter(c => c.variant_id !== variantIdNecessaire);
            
            if (coffretsExistants.length === 1 && coffretBonVariant) {
              // Bon variant déjà là : juste maj note
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: noteCalculee })
              }).finally(() => {
                isUpdatingCoffret = false;
                toggleDrawerInteractions(false);
              });
              return;
            }
            
            const updates = {};
            coffretsMauvaisVariant.forEach(c => { updates[c.key] = 0; });
            
            if (coffretBonVariant) {
              updates[coffretBonVariant.key] = coffretQuantiteTotal;
              coffretsExistants.filter(c => c.variant_id === variantIdNecessaire && c.key !== coffretBonVariant.key).forEach(c => {
                updates[c.key] = 0;
              });
              
              cartUpdate(updates, noteCalculee)
                .finally(() => {
                  setTimeout(() => {
                    isUpdatingCoffret = false;
                    toggleDrawerInteractions(false);
                  }, 1500);
                });
            } else {
              // Cas remplacement de coffret : suppression → ajout → note APRÈS
              cartUpdate(updates)
                .then(() => cartAdd(variantIdNecessaire, coffretQuantiteTotal, messageExistant))
                .then(() => fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ note: noteCalculee })
                }))
                .finally(() => {
                  setTimeout(() => {
                    isUpdatingCoffret = false;
                    toggleDrawerInteractions(false);
                  }, 1500);
                });
            }
            
          } else {
            // 4. Coffret n'existe pas → juste maj note
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteCalculee })
            }).finally(() => {
              isUpdatingCoffret = false;
              toggleDrawerInteractions(false);
            });
            return;
          }
        })
        .catch(() => {
          isUpdatingCoffret = false;
          toggleDrawerInteractions(false);
        });
    }
    
    // Events
    document.addEventListener('cart:updated', function() {
      if (!coffretDesactive && !isUpdatingCoffret) {
        planifierAnalyse(1500);
      }
    });
    
    document.addEventListener('ajaxProduct:added', function(evt) {
      const detail = evt.detail || {};
      const productId = detail.product_id || detail.productId;
      const variantId = detail.variant_id || detail.variantId;
      const handle = detail.handle || '';
      
      if (coffretDesactive) {
        if (
          (productId && (
            (coffretData.speakers && coffretData.speakers.includes(productId)) || 
            (coffretData.figurines && coffretData.figurines.includes(productId)) || 
            (coffretData.casquesSacoches && coffretData.casquesSacoches.includes(productId)) ||
            (coffretData.malettes && coffretData.malettes.includes(productId))
          )) ||
          (variantId && (
            etageresSimplesVariants.includes(variantId) ||
            etageresMinLVariants.includes(variantId)
          ))
        ) {
          coffretDesactive = false;
        }
      }
      
      if (!coffretDesactive) {
        const delai = (productId === COFFRET_PRODUCT_ID || handle === COFFRET_HANDLE) ? 2000 : 800;
        planifierAnalyse(delai);
      }
    });
    
    document.addEventListener('page:loaded', function() {
      planifierAnalyse(300);
    });
    
    planifierAnalyse(300);
  }
  
  gestionCoffretCadeau();
});


document.addEventListener("DOMContentLoaded", function() {
  if ( !!document.querySelector(".pack-figurines") === false && !!document.querySelector(".variant-picker:not(.variant-picker-coffret)") === true ){
    var variant_pickers = document.querySelectorAll(".variant-picker:not(.variant-picker-coffret) label");
    for (var i = 0; i < variant_pickers.length; i++) {
      variant_pickers[i].addEventListener('click', function(event) {
        setTimeout(function () {
          var regular_price = document.querySelector(".product__info .product__price .price__regular").textContent;
          document.querySelector('form.product-form .product-form__submit .btn-text .normal-price-atc').setAttribute("data-after", regular_price);
          var price_sale = document.querySelector('.product__info .product__price .price__sale');
          if (price_sale){
            document.querySelector('form.product-form .product-form__submit .btn-text .compare-price-atc').setAttribute("data-after", price_sale.textContent);
          }else{
            document.querySelector('form.product-form .product-form__submit .btn-text .compare-price-atc').setAttribute("data-after", "");
          }
        }, 500);
      });
    }
  }
});